const translations = {
  "sidebar.Payments": "გადახდები",
  "sidebar.Dashboard": "დეშბორდი",
  "sidebar.Finances": "ფინანსები",
  "sidebar.References": "საცნობარო",
  "sidebar.Reports": "რეპორტები",

  "sidebar.MainPage": "მთავარი გვერდი",
  "sidebar.Documentation": "დოკუმენტაცია",
  "sidebar.ProductsAndProviders": "პროდუქტები და პროვაიდერები",
  "sidebar.InvoicesAndGraphs": "ინვოისები და გრაფიკები",
  "sidebar.Changes": "ცვლილებები",
  "sidebar.CorrectPersonalData": "გასასწორებელი პირადი მონაცემები",
  "sidebar.Documents": "დოკუმენტები",
  "sidebar.Confirmations": "დასადასტურებელი",
  "sidebar.reallywantCancel?": "ნამდვილად გსურს ვიზიტის გაუქმება?",
  "sidebar.no": "არა",
  "sidebar.yesInformal": "დიახ",
};

export default translations;
